var _path, _mask;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58 12.316l13.5-10.5a1.5 1.5 0 011.84 0l13.5 10.5A1.5 1.5 0 0133 13.5V30a4.5 4.5 0 01-4.5 4.5h-21A4.5 4.5 0 013 30V13.5c0-.463.214-.9.58-1.184zM15 31.5h6v-12h-6v12zm9 0V18a1.5 1.5 0 00-1.5-1.5h-9A1.5 1.5 0 0012 18v13.5H7.5A1.5 1.5 0 016 30V14.234L18 4.9l12 9.334V30a1.5 1.5 0 01-1.5 1.5H24z",
    fill: "#777E8C"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "home_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 30,
    height: 34
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58 12.316l13.5-10.5a1.5 1.5 0 011.84 0l13.5 10.5A1.5 1.5 0 0133 13.5V30a4.5 4.5 0 01-4.5 4.5h-21A4.5 4.5 0 013 30V13.5c0-.463.214-.9.58-1.184zM15 31.5h6v-12h-6v12zm9 0V18a1.5 1.5 0 00-1.5-1.5h-9A1.5 1.5 0 0012 18v13.5H7.5A1.5 1.5 0 016 30V14.234L18 4.9l12 9.334V30a1.5 1.5 0 01-1.5 1.5H24z",
    fill: "#fff"
  }))));
}

export default __webpack_public_path__ + "58e3d6c6d8daabcd25907c44ee619b1d.svg";
export { SvgHome as ReactComponent };